import { createReducer } from '../../../utils/';
import { combineReducers } from 'redux';
import constant from './constant';
import moment from 'moment';

const execInfosHandlers = {
    [constant.execInfos](state, action) {
        return action.payload;
    }
};

const loadingHandlers = {
    [constant.loading](state, action) {
        return action.payload;
    },
}

const urlHandlers = {
    [constant.url](state, action) {
        return action.payload;
    },
}

const searchHandlers = {
    [constant.search](state, action) {
        return { ...state, ...action.payload }
    }
};

export const loading = createReducer(false, loadingHandlers);
export const search = createReducer({ 'time[0]': moment().format('YYYY-MM-DD') }, searchHandlers);
export const execInfos = createReducer({}, execInfosHandlers);
export const url = createReducer('', urlHandlers);
export const everydayExecInfo = combineReducers({
    loading,
    search,
    execInfos,
    url,
})






// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/everydayExecInfo/reducers.js